import { render } from "./Login.vue?vue&type=template&id=195ce23c&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=195ce23c&lang=scss"
import "./Login.vue?vue&type=style&index=1&id=195ce23c&lang=scss&scoped=true"

import exportComponent from "G:\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195ce23c"]])

export default __exports__